/*
 * The only file in the frontend that names a module (modules.md §8, mirroring
 * cmd/teambase/modules.go). Switching a module off is deleting its line from `modules`; everything
 * else — core frames, the router, the reducer, the translations, the boot's binding — reaches a
 * module through the registry and the one record each module exports (`FrontendModule`), so nothing
 * here knows what a module does.
 */

import type { FrontendModule } from "./core/modules/registry.ts"
import aichat from "./modules/aichat/index.ts"
import chat from "./modules/chat/index.ts"
import drive from "./modules/drive/index.ts"

/** In registration order: slot contributions are concatenated, and modules bound, in it. */
export const modules: FrontendModule[] = [chat, aichat, drive]
